// VG2 · Saved analyses client (owner-scoped).
// Uses the owner-authenticated axios (vg2_token) and also forwards the
// anon token so a logged-in owner viewing their own still-anon VALUTA can
// save without re-compiling (the backend re-parents the case).
import { api } from "@/lib/api";

const LS_ANON = "vg2_anon_token";

function anonHeader() {
  const t = localStorage.getItem(LS_ANON);
  return t ? { "X-VG2-Anon-Token": t } : {};
}

export const saveAnalysis = async ({ caseId, analysisId, scenarioKey = null, scenarioTitle = null, label = null }) =>
  (await api.post("/v2/owner/saved-analyses", {
    case_id: caseId,
    analysis_id: analysisId,
    scenario_key: scenarioKey,
    scenario_title: scenarioTitle,
    label,
  }, { headers: anonHeader() })).data;

export const listSavedAnalyses = async () =>
  (await api.get("/v2/owner/saved-analyses")).data;

export const deleteSavedAnalysis = async (savedId) =>
  (await api.delete(`/v2/owner/saved-analyses/${savedId}`)).data;
